import React, { Component } from "react";
import { Link } from "react-router-dom";
import Ripple from "material-ui/internal/TouchRipple";
import IconButton from "material-ui/IconButton";
import ExpandIcon from "material-ui/svg-icons/navigation/expand-more";

import "./NavItem.css";

export default class NavItem extends Component {
  toggle = () => {
    const { opened, to } = this.props;
    opened ? this.props.closeItem(to) : this.props.openItem(to);
  };

  clicked = () => {
    const { to, openItem, closeDrawer } = this.props;
    openItem(to);
    closeDrawer();
  };

  toggler = children => {
    if (children) {
      return (
        <IconButton onClick={this.toggle}>
          <ExpandIcon />
        </IconButton>
      );
    }
  };

  subs(children) {
    if (children) {
      return (
        <div className="nav-item--subs">
          {children.map((child, i) =>
            React.cloneElement(child, { key: i, spaced: true })
          )}
        </div>
      );
    }
  }

  selectedStyle() {
    const { selected, to, children } = this.props;
    if (selected.indexOf(to) === 0 && !children) {
      return {
        backgroundColor: "#eee"
      };
    }
  }

  spacer(spaced) {
    if (spaced) {
      return <span className="nav-item--spacer" />;
    }
  }

  render() {
    const { icon, title, to, spaced, children } = this.props;
    const classes = this.props.opened ? "nav-item" : "nav-item closed";

    return (
      <div className={classes}>
        <div className="nav-item--entry" style={this.selectedStyle()}>
          <Ripple>
            {this.spacer(spaced)}
            <Link onClick={this.clicked} to={to} style={this.selectedStyle()}>
              {icon}
              <span>{title}</span>
            </Link>
          </Ripple>
          {this.toggler(children)}
        </div>
        {this.subs(children)}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/NavItem.js